import { GetterTree } from 'vuex'
import { DialogsState } from './types'
import { RootState } from '@/store/types'

export const getters: GetterTree<DialogsState, RootState> = {}
